var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchField"},[_c('autocomplete-field',{attrs:{"placeholder":_vm.$t('core.header.search.searchText'),"options":_vm.targets},on:{"selected":_vm.onItemSelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }